export const ORDER_ACCESS_IDENTIFIERS = [
  "orders.view",
  "orders.manage",
  "SuperAdmin",
  "CountryLevel",
  "RegionLevel",
  "ZoneLevel",
  "WoredaLevel",
  "LaboratoryLevel",
  "HubLevel",
  "FacilityManager",
  "PharmacyHead",
];
